<div class="container-fluid" [ngStyle]="{background: color}">
  <div class="row p-3 scrollable">
    <div class="col-12 col-md-5 col-lg-4 col-xl-3 ">
      <div class="row">
      <div class="col-12 setting-item">
      <div class="user-profile" *ngIf="isUser" >
        <div class="d-flex profile-border" (click)="onChanges()">
          <div class="icons d-flex align-items-center justify-content-center">
            <img src="/assets/images/userProfile.png" height="50px" width="50px" alt="">
          </div>
          <div class="d-block pl-3 pt-3">
            <div class="user-name">
             {{userData.first_name}} {{userData.last_name}}
            </div>
            <div class="user-email">
             {{userData.email}}
            </div>
          </div>
          <div class="manage-user ml-4 d-flex pt-2 pr-1 align-items-center">
            <p class="pl-2 pr-2 pt-1 pb-1 cursor-pointer">
             <img src="/assets/images/arrow-right.svg" class="pl-1 pr-1" alt="">

            </p>
          </div>
        </div>
      </div>
      <div class="user-profile  cursor-pointer" *ngIf="!isUser" (click)="login()">
        <div class="d-flex profile-border">
          <div class="icons d-flex align-items-center justify-content-center">
            <img src="/assets/images/userProfile.png" height="45px" width="45px" alt="">
          </div>
          <div class="d-flex align-items-center pl-3">
            <div class="user-name">
            Login Or Register
            </div>
            <div class="user-email">
            </div>
          </div>
        </div>
      </div>
      </div>

      </div>

      <!-- <app-useraccount></app-useraccount> -->
       <div class="row" *ngIf="isProfile">
        <div class="col-12 setting-item" (click)="switchProfile()">
          <div class="d-flex pl-2 pb-1 align-items-center">
            <img [src]="playlistProfile.profile_image" height="45px" width="45px" style="border-radius: 50%;" alt="">
            <div class="d-flex justify-content-between align-items-center w-100">
              <div class="p-3 " >{{playlistProfile.profile_name}}</div>
              <div class="switch pr-3 d-flex align-items-center"> {{'SETTING.SWITCH_PROFILE' | translate}}<span>
                <!-- <i class="fas fa-angle-right ml-2 fs-24"></i> -->
             <img src="/assets/images/arrow-right.svg" class="pl-1 pr-1" alt="">
              
              </span></div>
            </div>
          </div>
        </div>
       </div>
       <div class="row setting-lists" >
        <div class="col-12 setting-item" *ngFor="let item of settingData" (click)="onChange(item.name)">
          <div class="d-flex  align-items-center justify-content-between items">
            <div class="p-3"  [ngClass]="{'active-setting': isActiveSetting(item.name)}" >{{item.name | translate}}</div>
           <span style="color: #676565;font-size: 18px;padding-right: 1em;">
            <!-- <i class="fa fa-angle-right"></i> -->
             <img src="/assets/images/arrow-right.svg" alt="">
          </span>
          </div>

        </div>
      </div>
    </div>
    <div class="col-12 col-md-7 col-lg-8 col-sm-6 col-xl-9">
      <div class="d-block" *ngIf="isUserData">
      <app-useraccount></app-useraccount>
         <!-- <div class="d-flex pl-3 pt-5"> -->
        <div class="mjm">
          <div class="d-flex align-items-center justify-content-center">
            <button class="btn btn-switch fs-20" *ngIf="multi_profile == false && isLocalPlaylist == true" (click)="switchPlaylistLocal()"> <i class="fas fa-exchange-alt mr-2"></i>{{'SETTING.SWITCH_PLAYLIST' | translate}}</button>
          </div>
          <div class="d-flex align-items-center justify-content-center">
            <button class="btn btn-switch fs-20" *ngIf="multi_profile == true" (click)="logoutPlaylist()"> <i class="fa fa-power-off mr-2"></i> Logout Playlist</button>
          </div>
          <!-- <div class="d-flex align-items-center justify-content-center ">
            <button class="btn btn-switch fs-20" *ngIf="multi_profile == false && !isLocalPlaylist == true" (click)="switchProfile()"> <i class="fas fa-exchange-alt mr-2"></i> Switch Profile  &nbsp;</button>
          </div> -->
          <div class="d-flex align-items-center justify-content-center mt-3">
            <button class="btn btn-switch fs-20" *ngIf="multi_profile == false && !isLocalPlaylist == true" (click)="switchPlaylist()"> <i class="fas fa-exchange-alt mr-2"></i>{{'SETTING.SWITCH_PLAYLIST' | translate}}</button>
          </div>
        </div>
      </div>
      <div class="d-flex" *ngIf="manageAccount"  class="m-auto auth-backgrounds">
        
      <div class="container-fluid">
      <div class="row  justify-content-center align-items-center h-100">
        <div class="login-card">
        <div class="col-12 text-center">
          <h3 class="login-label mb-4">{{'USERINFO.MANAGE_ACCOUNT' | translate}}</h3>
          <div class="profile-pics position-relative">
            <img src="/assets/images/userProfile.png" alt="profile pic" height="160px" width="160px">
            <!-- <span class="profile-edit"> <i class="fa fa-edit fs-24"  data-toggle="modal" data-target="#categoryModal"></i></span> -->
          </div>
          <div class="uname-uemail pt-3">
            <div class="name fs-20">
            {{userData.first_name}} {{userData.last_name}}
            </div>
            <div class="email pt-1">
             {{userData.email}}
            </div>
          </div>
        </div>
        <div class="card-input col-md-12 col-xl-12 ">
            <div class="col-12 pb-4 text-center mt-5">
               <div class="switch-Playlist" (click)="switchPlaylist()">
                <button class="btn text-light">
                   <!-- <i class="fas fa-exchange-alt fs-20 mr-2"></i>  -->
                 {{'SETTING.SWITCH_PLAYLIST' | translate}}
                  </button>
                   <span class="right-arrow"><i class="fa fa-angle-right"></i></span>
               </div>
               <div class="change d-flex justify-content-between"  (click)="openModal()">
                <button class="btn text-light" >
                        <!-- <span class="fa-passwd-reset fa-stack">
                         <i class="fa fa-undo fa-stack-2x"></i>
                         <i class="fa fa-key fa-stack-1x"></i>
                        </span> -->
                  {{'SETTING.CHANGE_PASSWORD' | translate}}
                </button>
                   <span class="right-arrow"><i class="fa fa-angle-right"></i></span>

               </div>
               <div class="logout d-flex align-items-start" (click)="logout()">
                <button class="btn text-light d-flex align-items-start">
                  <!-- <i class="fa fa-sign-out fs-22 mr-2"></i> -->
                 {{'HOME.LOGOUT' | translate}}</button>
               </div>
               <div class="delete  d-flex justify-content-start" (click)="openModals()">
                <button class="btn text-danger">
                  <!-- <i class="fa fa-trash fs-20 text-light mr-2"></i> -->
                 {{'SETTING.DELETE_ACCOUNT' | translate}}
                </button>
               </div>
            </div>
        </div>
        </div>
        </div>
    </div>

<div class="modal right fade" id="categoryModals" #categoryModalRefs tabindex="-1" role="dialog" aria-labelledby="categoryModal">
  <div class="modal-dialog" role="document">
    <div class="modal-content">

      <div class="modal-header" style="position: sticky;top: 0;">
        <h5 class="modal-title text-dark pl-3" id="categoryModal">{{'HOME.DELETE_CONFIRMATION' | translate}}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
      </div>

      <div class="modal-body">
        
      <div class="rows cat-item"  >
  <form #deleteForm="ngForm" (ngSubmit)="ondeleteSubmit(deleteForm)" style="width: 100%; display: contents;">
        <div class="cat-width" >
          <div class="categories">
            <!-- current password  -->
          <label class="d-flex justify-content-start mt-3">Enter Password</label>
          <div class="form-group mb-2 mt-2 position-relative">
          <i class="fa fa-key text-white input-icon" aria-hidden="true"></i>
          <input
            [type]="types"
            class="form-control-pass w-100"
            name="Password"
            placeholder="Enter Password"
            [(ngModel)]="deleteUser.password"
            maxlength="15"
            required
            #password="ngModel"
            autofocus
          />
          <div class="input-append cursor-pointer text-white" (click)="hideShowPassword()">
            <i class="fas fa-eye" *ngIf="types === 'password'"></i>
            <i class="fas fa-eye-slash" *ngIf="types !== 'password'"></i>
          </div>
        </div>        
        <!-- <p class="text-left text-danger" *ngIf="password.invalid && password.touched">
          Password is required.
        </p> -->
        <p class="text-left text-danger" *ngIf="password.invalid && password.touched">
        <span *ngIf="password.errors?.['required']"> Password is required.</span>
        <!-- <span *ngIf="currentPassword.errors?.['minlength']">Password should be at least 6 characters.</span> -->
        </p>
          </div>
        </div>
        <div class="w-100 d-flex justify-content-around mt-3">
          <div class="cancel">
            <button class="btn" (click)="cancels()">Cancel</button>
          </div>
          <div class="submit">
            <button class="btn">Submit</button>
          </div>
        </div>
         </form>
      
      </div>

      </div>
      <!-- modal-content -->
      </div>
      <!-- modal-dialog -->
    </div>
    </div>

<div class="modal right fade" id="categoryModal" #categoryModalRef tabindex="-1" role="dialog" aria-labelledby="categoryModal">
  <div class="modal-dialog" role="document">
    <div class="modal-content">

      <div class="modal-header" style="position: sticky;top: 0;">
        <h5 class="modal-title text-dark pl-3" id="categoryModal">Change Password</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
      </div>

      <div class="modal-body">
        
      <div class="rows cat-item"  >
  <form #registerForm="ngForm" (ngSubmit)="onRegisterSubmit(registerForm)" style="width: 100%; display: contents;">
        <div class="cat-width" >
          <div class="categories">
            <!-- current password  -->
               <label class="d-flex justify-content-start mt-3">Current Password</label>
          <div class="form-group mb-2 mt-2 position-relative">
          <i class="fa fa-key text-white input-icon" aria-hidden="true"></i>
          <input
            [type]="types"
            class="form-control-pass w-100"
            name="currentPassword"
            placeholder="Current Password"
            [(ngModel)]="registerUser.currentPassword"
            maxlength="15"
            required
            #currentPassword="ngModel"
            autofocus
          />
          <div class="input-append cursor-pointer text-white" (click)="hideShowPassword()">
            <i class="fas fa-eye" *ngIf="types === 'password'"></i>
            <i class="fas fa-eye-slash" *ngIf="types !== 'password'"></i>
          </div>
        </div>        
        <!-- <p class="text-left text-danger" *ngIf="password.invalid && password.touched">
          Password is required.
        </p> -->
        <p class="text-left text-danger" *ngIf="currentPassword.invalid && currentPassword.touched">
        <span *ngIf="currentPassword.errors?.['required']">Current Password is required.</span>
        <!-- <span *ngIf="currentPassword.errors?.['minlength']">Password should be at least 6 characters.</span> -->
        </p>
             <!--New Password -->
          <label class="d-flex justify-content-start mt-3">New Password</label>
          <div class="form-group mb-2 mt-2 position-relative">
          <i class="fa fa-key text-white input-icon" aria-hidden="true"></i>
          <input
            [type]="registerPasswordType"
            class="form-control-pass w-100"
            name="password"
            placeholder="New Password"
            [(ngModel)]="registerUser.password"
            maxlength="15"
            minlength="6"
            required
            #password="ngModel"
            autofocus
          />
          <div class="input-append cursor-pointer text-white" (click)="hideShowRegisterPassword()">
            <i class="fas fa-eye" *ngIf="registerPasswordType === 'password'"></i>
            <i class="fas fa-eye-slash" *ngIf="registerPasswordType !== 'password'"></i>
          </div>
        </div>        
        <!-- <p class="text-left text-danger" *ngIf="password.invalid && password.touched">
          Password is required.
        </p> -->
        <p class="text-left text-danger" *ngIf="password.invalid && password.touched">
        <span *ngIf="password.errors?.['required']">Password is required.</span>
        <span *ngIf="password.errors?.['minlength']">Password should be at least 6 characters.</span>
        </p>

        <label class="d-flex justify-content-start mt-3">Confirm Password</label>
        <div class="form-group mb-2 mt-2 position-relative">
        <i class="fa fa-key text-white input-icon" aria-hidden="true"></i>
        <input
        [type]="confirmPasswordType"
        class="form-control-pass w-100"
        name="confirmPassword"
        placeholder="Confirm Password"
        [(ngModel)]="registerUser.confirmPassword"
        required
        #confirmPassword="ngModel"
        />
        <div class="input-append cursor-pointer text-white" (click)="hideShowConfirmPassword()">
            <i class="fas fa-eye" *ngIf="confirmPasswordType === 'password'"></i>
            <i class="fas fa-eye-slash" *ngIf="confirmPasswordType !== 'password'"></i>
          </div>  
        </div>
        <p class="text-left text-danger" *ngIf="confirmPassword.errors?.required && confirmPassword.touched && !confirmPassword.errors?.mismatch">
          Confirm password is required.
        </p>
        <p class="text-left text-danger" *ngIf="confirmPassword.errors?.mismatch && confirmPassword.touched">
          Passwords do not match.
        </p>
          </div>
        </div>
        <div class="w-100 d-flex justify-content-around mt-3">
          <div class="cancel">
            <button class="btn" (click)="cancel()">Cancel</button>
          </div>
          <div class="submit">
            <button class="btn">Submit</button>
          </div>
        </div>
  </form>
      
      </div>

      </div>
      <!-- modal-content -->
      </div>
      <!-- modal-dialog -->
    </div>
    </div>
    </div>
      <!-- </div> -->
      <div class="row" *ngIf="timeFormat">
        <div class="col-12">
          <div class="format-head d-flex justify-content-center align-items-center mt-3">
            <h3>{{'SETTING.TIME_FORMAT' | translate}}</h3>
          </div>
          <div class="radio-btn ">
            <div class="format12h cursor-pointer">
              <input type="radio" value="12h" [(ngModel)]="selectedFormat" (change)="onTimeFormatChange($event)">
              <span class="pl-2">
                12 {{'SETTING.TIME' | translate}}
              </span>
            </div>
            <div class="format24h cursor-pointer">
              <input type="radio" value="24h" [(ngModel)]="selectedFormat" (change)="onTimeFormatChange($event)">
              <span class="pl-2">
                24 {{'SETTING.TIME' | translate}}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-center align-items-center mt-2" *ngIf="isrefresh">
        <div class="mt-2">
         <h3>{{'SETTING.REFRESH_DATA' | translate}}</h3>
            <div class="refresh-livetv">
            <button class="btn d-flex justify-content-start align-items-center" (click)="refreshContent('livetv')">
              <span style="width: 50px;">
                <svg _ngcontent-akf-c72="" width="29" height="29" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg" class="isvg"><g _ngcontent-akf-c72="" clip-path="url(#clip0_1_262)"><path _ngcontent-akf-c72="" id="s" d="M1.23489 3.3944C1.13337 3.44249 0.994444 3.56538 0.930326 3.6669L0.807434 3.84857V6.56289V9.28255H3.15842H5.5094V6.29038V3.29822H3.46832C1.62494 3.29822 1.40587 3.30891 1.23489 3.3944Z" fill="white"></path><path _ngcontent-akf-c72="" id="s" d="M7.16583 14.3585V25.4189H14.4859H21.8061V14.3585V3.29823H14.4859H7.16583V14.3585ZM12.8242 10.5649C13.7432 11.0565 18.2368 13.712 18.3437 13.8242C18.6322 14.1395 18.6322 14.5776 18.3437 14.8929C18.2315 15.0104 13.5081 17.7995 12.7761 18.1789C12.4823 18.3338 12.1082 18.2911 11.8785 18.0774C11.5953 17.8209 11.6006 17.9278 11.6006 14.3585C11.6006 11.6122 11.6113 11.0137 11.6754 10.8962C11.8999 10.4634 12.3807 10.3245 12.8242 10.5649Z" fill="white"></path><path _ngcontent-akf-c72="" id="s" d="M23.4624 6.29038V9.28255H25.8134H28.1644V6.56289V3.84857L28.0415 3.6669C27.7957 3.29822 27.785 3.29822 25.5088 3.29822H23.4624V6.29038Z" fill="white"></path><path _ngcontent-akf-c72="" id="s" d="M0.807434 14.3585V17.7782H3.15842H5.5094V14.3585V10.9389H3.15842H0.807434V14.3585Z" fill="white"></path><path _ngcontent-akf-c72="" id="s" d="M23.4624 14.3585V17.7782H25.8134H28.1644V14.3585V10.9389H25.8134H23.4624V14.3585Z" fill="white"></path><path _ngcontent-akf-c72="" id="s" d="M0.807434 22.1542V24.8685L0.930326 25.0502C1.17611 25.4189 1.1868 25.4189 3.46832 25.4189H5.5094V22.4267V19.4345H3.15842H0.807434V22.1542Z" fill="white"></path><path _ngcontent-akf-c72="" id="s" d="M23.4624 22.4267V25.4189H25.5088C27.785 25.4189 27.7957 25.4189 28.0415 25.0502L28.1644 24.8685V22.1542V19.4345H25.8134H23.4624V22.4267Z" fill="white"></path></g><defs _ngcontent-akf-c72=""><clipPath _ngcontent-akf-c72="" id="clip0_1_262"><rect _ngcontent-akf-c72="" width="27.3569" height="27.3569" fill="white" transform="translate(0.807434 0.680084)"></rect></clipPath></defs></svg>
              </span>
                <span class="pl-2">
            {{'SETTING.REFRESH_LIVETV' | translate}}
                </span>
          </button>
            </div>
            <div class="refresh-movie">
              <button class="btn d-flex justify-content-start align-items-center" (click)="refreshContent('movies')">
                <span style="width: 50px;">
                  <svg _ngcontent-rec-c72="" width="31" height="32" viewBox="0 0 31 32" fill="none" xmlns="http://www.w3.org/2000/svg" class="isvg"><path _ngcontent-rec-c72="" id="s" d="M13.3558 26.1752H17.6161V28.9831H13.3558V26.1752Z" fill="white"></path><path _ngcontent-rec-c72="" id="s" d="M25.0717 30.3872H5.90051C5.60709 30.3872 5.36798 30.7017 5.36798 31.0892V31.7911H25.6042V31.0892C25.6042 30.7017 25.3651 30.3872 25.0717 30.3872Z" fill="white"></path><path _ngcontent-rec-c72="" id="s" d="M30.3967 0.904236H0.574951C0.281526 0.904236 0.0424194 1.21872 0.0424194 1.60621V24.0694C0.0424194 24.4568 0.281526 24.7713 0.574951 24.7713H30.3967C30.6901 24.7713 30.9293 24.4568 30.9293 24.0694V1.60621C30.9293 1.21872 30.6901 0.904236 30.3967 0.904236ZM29.8642 22.6654C29.8642 23.0536 29.6256 23.3674 29.3317 23.3674H1.64001C1.34606 23.3674 1.10748 23.0536 1.10748 22.6654V3.01016C1.10748 2.62196 1.34606 2.30818 1.64001 2.30818H29.3317C29.6256 2.30818 29.8642 2.62196 29.8642 3.01016V22.6654Z" fill="white"></path><path _ngcontent-rec-c72="" id="s" d="M2.17249 21.9633H28.7991V3.71204H2.17249V21.9633ZM18.681 10.7318C18.681 10.3436 18.9195 10.0298 19.2135 10.0298H22.4087V11.4337H19.746V12.1357H21.8762V13.5397H19.746V14.2416H22.4087V15.6456H19.2135C18.9195 15.6456 18.681 15.3318 18.681 14.9436V10.7318ZM13.8882 10.0298H14.9532V12.5471L16.0183 13.951L17.0834 12.5471V10.0298H18.1484V12.8377C18.1484 13.0244 18.0925 13.2027 17.9924 13.334L16.3948 15.4399C16.291 15.5768 16.1546 15.6456 16.0183 15.6456C15.882 15.6456 15.7457 15.5768 15.6418 15.4399L14.0442 13.334C13.9441 13.2027 13.8882 13.0244 13.8882 12.8377V10.0298ZM12.2906 10.0298H13.3556V15.6456H12.2906V10.0298ZM8.03033 10.0298H9.0954V14.2416H11.7581V15.6456H8.56286C8.26891 15.6456 8.03033 15.3318 8.03033 14.9436V10.0298Z" fill="white"></path></svg>
                </span>
                <span class="pl-2">
                {{'SETTING.REFRESH_MOVIES' | translate}}
                  </span>
              </button>
            </div>
            <div class="refresh-series">
              <button class="btn d-flex justify-content-start align-items-center" (click)="refreshContent('series')">
                <span style="width: 50px;"><i class="fa fa-video fs-24"></i></span>
                <span class="pl-2">
                {{'SETTING.REFRESH_SERIES' | translate}}
                </span>
              </button>
            </div>
            <div class="refresh-all" (click)="refreshContent('all')">
              <button class="btn d-flex justify-content-start align-items-center">
                <span style="width: 50px;">
                 <i class="fas fa-sync fs-24"></i>
                </span>
                <span class="pl-2">
                  {{'SETTING.REFRESH_ALL' | translate}}
                </span>
              </button>
            </div>
        </div>
      </div>
      <div class="d-flex justify-content-center  align-items-center color-height pt-2" *ngIf="isLanguage">
        <app-language></app-language>
        <!-- <app-change-color></app-change-color> -->
      </div>
      <div class="d-flex justify-content-center align-items-center pt-2" *ngIf="isStreamFormat">
        <div class="mjm">
          <h3 class="header-label">
            {{ 'HOME.SOURCE_TYPE' | translate }}
          </h3>  
          <select class="w-100 text-capitalize mt-3" (change)="changeVideoFormat($event)">
            <option [value]="item.format" class="text-capitalize" *ngFor="let item of videoSourceType" [selected]="item.format === formatType">
              {{item.name | uppercase }}
            </option>
          </select>
        </div>
      </div>
      <div class="d-flex pt-2" *ngIf="isprivacy">
      </div>
    </div>
      <!-- <div class="row p-3 mt-3 d-flex ">
        <div class=" col-md-3 col-xl-5"></div>
        <div class="container-fluid">
        <select name="" id="" class="form-control" (change)="onChangeColor($event)">
          <option *ngFor="let color of colorTheme" [value]="color.color"  [selected]="color.value===color.value">{{color.color}}</option>
          
        </select>
      </div>
      </div>
    </div> -->
    <!-- <div class="col-12 col-md-6">
        <app-change-color></app-change-color>
    </div> -->
    <!-- <div class="col-12  col-xl-2 setting-type pb-3">
      <div *ngFor="let item of listOfSettings; let i = index" class="mt-4 mb-md-5 mb-1 cursor-pointer"
        (click)="changeSettingType(item.value, i)">
        <button [ngClass]="(item.selected)? 'setting-btn-primary': 'setting-btn'" class="p-2"><i [ngClass]="item.icon"
            class="fs-20  ml-0" aria-hidden="true"></i>
          {{item.name}}</button>
      </div>
    </div>
    <div class="col-12 col-xl-10 ">
      <div *ngIf="settingType == 'user_account'">
        <app-useraccount></app-useraccount>
      </div>
      <div *ngIf="settingType == 'change_language'">
        <app-language></app-language>
      </div>
    </div> -->
  </div>
</div>
